import React, { useEffect, useState } from "react";
import Request from "@gcloud-npm/utils.fetch";
import {
  findOutEnvByEnvName,
  ENV_NAME,
  FAMILY_API,
} from "@gcloud-npm/utils.enums.environment";
import calculateHeaderParams from "@gcloud-npm/node.build-process.build-environments";
import IconGlyph from "@/bit/components/components.icon-glyph";
import Spinner from "@/bit/components/components.spin";

const familyApi = FAMILY_API.SSR_BACKEND;

const deleteItemCall = async ({
  build = false,
  updatedList,
  itemIdDotNotation,
  alias,
}) => {
  let context = { environment: findOutEnvByEnvName(process.env.NEXT_PUBLIC_ENV_NAME) };

  if (context.environment.name === ENV_NAME.LOCAL) {
    context = { environment: findOutEnvByEnvName("qa_ssr") };
  }

  const { "ssr-backend": connectionData } = context.environment;
  const { endpoint: host } = connectionData;
  const URL_API = `${host}/ad-api/v1/cms/edit-list/delete-item`;
  const headers = calculateHeaderParams(build, familyApi, context);

  const request = new Request({
    method: "POST",
    endpoint: URL_API,
    data: { frontList: updatedList, itemIdDotNotation, alias },
    headers: {
      ...headers,
      withCredentials: true,
    },
  });
  return request.makeRequest();
};

const removeAtIndex = (arr, index) => {
  return arr.slice(0, index).concat(arr.slice(index + 1));
};

const ConfirmDeleteCard = (props) => {
  const {
    cmsHandler,
    build,
    itemIndex,
    itemIdDotNotation,
    alias,
    setmaxWidth,
    frontalListToDelete,
  } = props;
  const [confirm, setconfirm] = useState(false);
  const [deleted, setdeleted] = useState(false);
  const [deletedError, setdeletedError] = useState(false);
  const [loading, setloading] = useState(false);

  const deleteItem = async () => {
    try {
      setloading(true);
      await deleteItemCall({
        build,
        updatedList: removeAtIndex(frontalListToDelete, itemIndex),
        itemIdDotNotation,
        alias,
      });
      setloading(false);
      setdeleted(true);
    } catch (error) {
      setdeletedError(true);
      setloading(false);
      console.log(
        `Error al eliminar el elemento ${itemIndex} del componente ${itemIdDotNotation} en la ficha ${alias}: ${error}`
      );
    }
  };

  useEffect(() => {
    setmaxWidth(confirm || deleted || deletedError);
  }, [confirm, deleted, deletedError]);

  return (
    cmsHandler && (
      <div className={`confirm-delete-card`}>
        {!confirm && (
          <div className="editable-group">
            <span
              className={"element-editable block delete-item"}
              onClick={() => setconfirm(true)}
            >
              <IconGlyph id="papelera-m" height={20} color="white" />
            </span>
          </div>
        )}

        {confirm && (
          <div className="confirm-delete-card--content">
            <div className="editable-group">
              <span
                className={"element-editable block"}
                onClick={() => setconfirm(false)}
              >
                <IconGlyph id="cerrar-m" height={20} color="white" />
              </span>
              <span
                className={"element-editable block"}
                onClick={() => deleteItem()}
              >
                <IconGlyph id="check-m" height={20} color="white" />
              </span>
            </div>
            <div>¿Borrar elemento?</div>
          </div>
        )}
        {deleted && (
          <div className="confirm-delete-card--content">
            <div>Borrado con éxito, recargue la página</div>
          </div>
        )}
        {deletedError && (
          <div className="confirm-delete-card--content">
            <div>
              Hubo un problema al borrar el elemento, si el problema persiste
              póngase en contacto con el equipo de desarrollo
            </div>
          </div>
        )}
        {loading && (
          <div className="confirm-delete-card--content">
            <Spinner
              size="small"
              operation="loading"
              fillColor={"#6B6C6F"}
              strokeColor={"#6B6C6F"}
            />
          </div>
        )}
        {/* INJECT_STYLED_JSX_TAG */}
      </div>
    )
  );
};

export default ConfirmDeleteCard;
